import { render, staticRenderFns } from "./ktpMy.vue?vue&type=template&id=6e94c16e&scoped=true"
import script from "./ktpMy.vue?vue&type=script&lang=ts"
export * from "./ktpMy.vue?vue&type=script&lang=ts"
import style0 from "./ktpMy.vue?vue&type=style&index=0&id=6e94c16e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e94c16e",
  null
  
)

export default component.exports